module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.total_collection_balance <= 0) ? _c('div', [_vm._m(0)]) : _c('div', [_c('h6', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('u', [_vm._v("My Collections")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(_vm.total_collection_balance)), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "sp-app-default-color"
  }, [_c('b', [_vm._v("Gigs: ")]), _vm._v("₦" + _vm._s(_vm.total_gigs_balance))]), _c('br')])]), _vm._v(" "), (((_vm.gigs_collection_balance > 0) && (!_vm.set_cashout_gig))) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.set_cashout_gig = true;
      }
    }
  }, [_vm._v("Cash Out Gig")]) : _vm._e(), _vm._v(" "), (_vm.set_cashout_gig) ? _c('div', [_c('p', [_vm._v("Enter the amount you want to cash out")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Processing Fee: ₦" + _vm._s(_vm.gigs_cash_out_proc_fee))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gigs_amount_to_cashout),
      expression: "gigs_amount_to_cashout"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.gigs_amount_to_cashout)
    },
    on: {
      "change": _vm.checkCashOutGigs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gigs_amount_to_cashout = $event.target.value
      }
    }
  }), _vm._v(" "), (((_vm.gigs_amount_to_cashout <= _vm.gigs_collection_balance))) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.cashOutGigs
    }
  }, [_vm._v("Cash Out")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {}, _vm._l((_vm.collections), function(col, bcdex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(col.data_account_with))]), _vm._v(" - " + _vm._s(col.data_account_transactions.length) + " Collections")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(col.data_account_transactions.length != 0) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabView('BCOL' + bcdex)
        }
      }
    }, [_vm._m(2, true)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_view['BCOL' + bcdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin": "0 1em"
      }
    }, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Date")]), _vm._v(" "), _vm._l((col.data_account_transactions), function(collection) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "40%",
          "font-size": "13px",
          "color": "#4d4b4b"
        }
      }, [_c('b', [_vm._v(_vm._s(collection.data_transaction_action_type_name))]), _c('br'), _vm._v(_vm._s(collection.data_transaction_service_type_name))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v("₦" + _vm._s(collection.data_transaction_amount))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(collection.data_transaction_reg_date))])])
    })], 2)])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {}, _vm._l((_vm.gigs), function(col, bcdex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(col.data_account_with))]), _vm._v(" - " + _vm._s(col.data_account_transactions.length) + " Collections")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(col.data_account_transactions.length != 0) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabView('BCOL' + bcdex)
        }
      }
    }, [_vm._m(4, true)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_view['BCOL' + bcdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin": "0 1em"
      }
    }, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Date")]), _vm._v(" "), _vm._l((col.data_account_transactions), function(collection) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "40%",
          "font-size": "13px",
          "color": "#4d4b4b"
        }
      }, [_c('b', [_vm._v(_vm._s(collection.data_transaction_action_type_name))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(collection.data_transaction_service_type_name)), _c('br'), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "#424141",
          "font-size": "12px"
        },
        domProps: {
          "innerHTML": _vm._s(collection.data_transaction_details)
        }
      })]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v("₦" + _vm._s(collection.data_transaction_amount))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(collection.data_transaction_reg_date))])])
    })], 2)])]) : _vm._e()])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have "), _c('b', [_vm._v("0")]), _vm._v(" Collections")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Collections from businesses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Gigs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-220b3949"}!./src/pages/Collections/template.html
// module id = 438
// module chunks = 0